import styled from 'styled-components';

type InputStyleType = {
  isLabelAboveField?: boolean;
  darkerLabel?: boolean;
  hideErrorMessage?: boolean;
};

export const InputBox = styled.div<InputStyleType>`
  display: ${(props) => (props.isLabelAboveField ? 'block' : 'flex')};
  text-align: ${(props) => (props.isLabelAboveField ? 'left' : 'right')};
  align-items: center;
  margin-bottom: ${({ hideErrorMessage }) => (hideErrorMessage ? 0 : 16)}px;
  gap: ${(props) => (props.isLabelAboveField ? 0 : 12)}px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    text-align: left;
  }
`;

export const InputLabel = styled.label<InputStyleType>`
  text-align: ${(props) => (props.isLabelAboveField ? 'left' : 'right')};
  font-size: 14px;
  flex: 1;
  display: block;
  line-height: 21px;
  min-height: 21px;
  color: ${(props) =>
    props.darkerLabel ? props.theme.colors['neutral-90'] : props.theme.colors['neutral-80']};
`;

export const InputArea = styled.div<InputStyleType>`
  position: relative;
  width: ${(props) => (props.isLabelAboveField ? '100%' : '50%')};
  flex-shrink: 0;

  button span {
    position: relative;
    top: 1px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }

  button {
    color: ${(props) => props.theme.colors['neutral-100']};
  }

  .chakra-menu__icon-wrapper {
    display: none;
  }

  button {
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors['neutral-20']};
    border-color: transparent;
    transition: background-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
    min-height: 48px;
    &:hover,
    &:focus,
    &[aria-checked='true'],
    &:active,
    &[data-active] {
      background-color: ${({ theme }) => theme.colors['neutral-30']};
    }
  }
  div {
    min-width: 100% !important;
    width: 100%;
    padding: 0;
  }
  div {
    ::-webkit-scrollbar {
      width: 0px;
    }

    ::-webkit-scrollbar-thumb {
      background: #888;
    }
  }
`;
